// extracted by mini-css-extract-plugin
module.exports = {"statsCard":"Scraped_statsCard__15Gfr"};